import { render, staticRenderFns } from "./createRow.vue?vue&type=template&id=4c8d8118&scoped=true&"
import script from "./createRow.vue?vue&type=script&lang=js&"
export * from "./createRow.vue?vue&type=script&lang=js&"
import style0 from "./createRow.vue?vue&type=style&index=0&id=4c8d8118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d8118",
  null
  
)

export default component.exports